import profile from "./profile.svg?raw"
import bag from "./bag.svg?raw"
import arrowUp from "./arrowUp.svg?raw"

export default {
    profile,
    bag,
    arrowUp
}
